import { app } from '../../app';

app.service('ConfirmDeleteModal', modal);

/** @ngInject */
function modal($uibModal) {

    return (messageKey) => {
        return $uibModal.open({
            component: 'confirmDelete',
            resolve: {messageKey: () => messageKey}
        }).result;
    };
}



// WEBPACK FOOTER //
// ./src/portal/modals/confirm-delete/confirm-delete.modal.js